// Section3.jsx
import styled from "styled-components";
import section3Image1 from "../../assets/images/section3_image1.png";
import section3Image2 from "../../assets/images/section3_image2.png";
import section3Image3 from "../../assets/images/section3_image3.png";
import section3Image4 from "../../assets/gif/section3_1.gif";
import section3Image5 from "../../assets/gif/section3_2.gif";
import section3Image6 from "../../assets/gif/section3_3.gif";
import section3Image7 from "../../assets/images/section3_image7.png";
import section3Image8 from "../../assets/gif/section3_4.gif";

// ===== 색상 토큰(필요하면 여기만 바꿔) =====
const ACCENT = "#ff2828";
const ACCENT_BG = "rgba(255,40,40,0.08)";
const TEXT_DARK = "#111827";
const TEXT = "#374151";
const BORDER = "#e5e7eb";

// ======================= 재사용 StepperList =======================
function StepperList({ items, titleOnly = false, className }) {
  return (
      <Steps className={className}>
        {items.map((it, idx) => (
            <Step key={idx}>
              <Badge>{idx + 1}</Badge>
              {idx !== items.length - 1 && <Rail />}
              <Content>
                <StepTitle>{it.title}</StepTitle>
                {!titleOnly && it.desc && <StepDesc>{it.desc}</StepDesc>}
              </Content>
            </Step>
        ))}
      </Steps>
  );
}

// ============================ Section3 ============================
function Section3() {
  // 고객용 단계
  const customerSteps = [
    {
      title: "회원가입",
      desc: "관공서, 지역축제, 지역소상공인 등 지역에 알리고 싶은 것들을 등록.",
    },
    { title: "광고 이미지 업로드", desc: "jpeg/gif 권장, 가로형(PPT) 사이즈." },
    { title: "광고 기간 선택", desc: "일 단위 설정." },
    { title: "광고희망 지역·지점 선택", desc: "지도에서 지점을 고르면 끝." },
    { title: "디지털사이니지", desc: "선택 지점(부동산중개사무소)에서 노출." },
  ];

  // 중개사무소 단계
  const realtorSteps = [
    { title: "회원가입", desc: "외부광고+매물광고 또는 매물광고만 선택." },
    {
      title: "매물등록",
      desc: "사진 최대 6장, 자체광고 이미지(jpeg/gif, 가로형) 추가.",
    },
    { title: "디지털사이니지", desc: "지점 전면 디스플레이에 노출." },
  ];

  return (
      <Section3Container>
        <Inner>
          <Title>광고방식</Title>

          {/* 광고를 원하는 고객 */}
          <Block>
            <BlockTitle>광고를 원하는 고객</BlockTitle>
            <StepperList items={customerSteps} />

            {/* 예시: 위 3썸네일, 아래 GIF 꽉차게 */}
            <Example>
              <ExampleTop>
                <Thumb>
                  <div className="box">
                    <img src={section3Image1} alt="전면" />
                  </div>
                  <figcaption>전면</figcaption>
                </Thumb>
                <Thumb>
                  <div className="box">
                    <img src={section3Image2} alt="2면" />
                  </div>
                  <figcaption>2면</figcaption>
                </Thumb>
                <Thumb>
                  <div className="box">
                    <img src={section3Image3} alt="6면" />
                  </div>
                  <figcaption>6면</figcaption>
                </Thumb>
              </ExampleTop>

              <ExampleBottom>
                <div className="screen">
                  <img src={section3Image4} alt="디지털사이니지 예시" />
                </div>
                <figcaption>디지털사이니지 — 실제 각화면 6·12초 단위</figcaption>
              </ExampleBottom>
            </Example>
          </Block>

          {/* 부동산중개사무소 */}
          <Block>
            <BlockTitle>부동산중개사무소</BlockTitle>
            <StepperList items={realtorSteps} />

            <Example>
              <ExampleTop>
                <Thumb>
                  <div className="box">
                    <img src={section3Image5} alt="전면(2초 단위)" />
                  </div>
                  <figcaption>전면 — 실제 이미지 각 2초</figcaption>
                </Thumb>
                <Thumb>
                  <div className="box">
                    <img src={section3Image6} alt="2면(2초 단위)" />
                  </div>
                  <figcaption>2면 — 실제 이미지 각 2초</figcaption>
                </Thumb>
                <Thumb>
                  <div className="box">
                    <img src={section3Image7} alt="6면" />
                  </div>
                  <figcaption>6면</figcaption>
                </Thumb>
              </ExampleTop>

              <ExampleBottom>
                <div className="screen">
                  <img src={section3Image8} alt="디지털사이니지 예시" />
                </div>
                <figcaption>디지털사이니지 — 실제 각화면 6·12초 단위</figcaption>
              </ExampleBottom>
            </Example>

            <OptionBox>
              <h4>• 선택사항</h4>
              <p>- 디스플레잉 시간 : 6초, 12초</p>
            </OptionBox>
          </Block>
        </Inner>
      </Section3Container>
  );
}

export default Section3;

// ============================ styles ============================
const Section3Container = styled.section`
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 100px 0;
  @media (max-width: 768px) {
    padding: 48px 0;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  @media (max-width: 768px) {
    padding: 0 16px;
    gap: 28px;
  }
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 800;
  color: ${TEXT_DARK};
  text-align: center;
  letter-spacing: -0.5px;
  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const Block = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BlockTitle = styled.h3`
  font-size: 24px;
  font-weight: 900;
  color: ${ACCENT};
  letter-spacing: -0.3px;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

/* ---- Stepper ---- */
const Steps = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Step = styled.li`
  position: relative;
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 12px;
  align-items: flex-start;
  padding-left: 2px;

  @media (max-width: 768px) {
    grid-template-columns: 32px 1fr;
    column-gap: 10px;
  }
`;

const Badge = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: ${ACCENT_BG};
  color: ${ACCENT};
  border: 1px solid ${ACCENT};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  margin-top: 2px;

  @media (max-width: 768px) {
    width: 26px;
    height: 26px;
    font-size: 13px;
  }
`;

const Rail = styled.span`
  position: absolute;
  left: 13px; /* 배지 중앙(28px/2) 보정 */
  top: 32px;  /* 배지 아래에서 시작 */
  bottom: -18px;
  width: 2px;
  background: linear-gradient(
    to bottom,
    ${ACCENT} 0,
    ${ACCENT} 8px,
    transparent 8px,
    transparent 16px
  );
  background-size: 100% 16px;
  opacity: 0.9;

  @media (max-width: 768px) {
    left: 12px;
    top: 30px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 2px;
`;

const StepTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: ${TEXT_DARK};
  line-height: 1.35;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const StepDesc = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${TEXT};
  line-height: 1.6;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

/* ---- Example ---- */
const Example = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const ExampleTop = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

const Thumb = styled.figure`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;

  .box {
    width: 100%;
    aspect-ratio: 4 / 3;
    border: 1px solid ${BORDER};
    border-radius: 16px;
    overflow: hidden;
    background: #f8fafc;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  figcaption {
    font-size: 16px;
    font-weight: 800;
    color: #222;
    text-align: center;
    margin-top: 4px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const ExampleBottom = styled.figure`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;

  .screen {
    width: 100%;
    aspect-ratio: 16 / 9; /* 아래 GIF 전체 너비 꽉차게 */
    border: 4px solid ${TEXT_DARK};
    border-radius: 16px;
    overflow: hidden;
    background: #000;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* gif 채움 */
    display: block;
  }
  figcaption {
    font-size: 16px;
    font-weight: 800;
    color: #222;
    text-align: center;
    margin-top: 4px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

/* ---- Option ---- */
const OptionBox = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  border: 1px dashed ${BORDER};
  border-radius: 16px;
  padding: 14px 16px;
  background: #fff;

  h4 {
    font-size: 20px;
    font-weight: 800;
    color: ${TEXT_DARK};
    margin: 0;
  }
  p {
    font-size: 16px;
    color: ${TEXT};
    margin: 0;
  }
`;
